//This is staticly data 

import React, { useState, useEffect, useContext, useRef } from "react";
import { plantCurveApi } from "../../../../../api/Api";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../assets/img/logos/logo 2.png';
import EnergyChartPower from "../../../../../components/charts/energy_reporting/EnergyChartPower";
import PlantEnergy from "../../dashboard/dashboardTabs/tab4Content/plantEnergy/PlantEnergy";
import { Box, Card, CardActions, CardHeader, Container, CssBaseline, Grid, IconButton, Paper, Stack, Typography, colors, useTheme,Button } from '@mui/material';
import AppModal from "../../../../../components/AppModal";
import InvverterFullSize from "../../../../../components/inverter/InvverterFullSize";
import { AppThemeContext } from "../../../../../context/AppThemeContext";
import DownloadJpegButton from "../../../../../components/downloadJpegButton/DownloadJpegButton";


// Utility function to format date as 'YYYY-MM-DD HH:mm'
const formatDateTime = (date) => {
    const pad = (num) => String(num).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};


export default function PlantCurveData() {
    const { PrimaryColor } = useContext(AppThemeContext);
const chartRef = useRef();

    const now = new Date(); // Current date and time

    // Set the startDate to 5:00 AM of the current date
    const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0);

    // Set the endDate to 8:00 PM (20:00) of the current date
    const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0);

    const [startDate, setStartDate] = useState(formatDateTime(initialStartDate)); // Set default start date
    const [endDate, setEndDate] = useState(formatDateTime(initialEndDate)); // Set default end date

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { spacing, palette, shape: { borderRadius } } = useTheme();

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);

    // Pagination States
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

    const [chartLabels, setChartLabels] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [gradientFill, setGradientFill] = useState(null);

    const credentials = {
        LOGIN_ID: localStorage.getItem("LoginID") || "",
        PASS_KEY: localStorage.getItem("KEY") || "xyz",
        LOC_CODE: localStorage.getItem("LCODE") || "",
        DT1: startDate,
        DT2: endDate,
        WEB_KEY: "WEBXYZ321"

    };

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await plantCurveApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);

                const labels = res.data.map((item) => item.datet);

                const datasets = [
                    {
                        label: "Load Total (kW)",
                        data: res.data.map((item) => parseFloat(item.TOTAL_LOAD_KW) || 0),
                        borderColor: "red",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                        pointHoverRadius: 1,
                    },
                    {
                        label: "Inverter Total (kW)",
                        data: res.data.map((item) => parseFloat(item.TOT_INV_KW) || 0),
                        borderColor: "blue",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                        pointHoverRadius: 1,
                    },
                    {
                        label: "Solar Meter Total (kW)",
                        data: res.data.map((item) => parseFloat(item.TOT_SOLAR_METER_KW) || 0),
                        borderColor: "yellow",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                        pointHoverRadius: 1,
                    },
                    {
                        label: "Mains Total (kW)",
                        data: res.data.map((item) => parseFloat(item.TOT_MAINS_KW) || 0),
                        borderColor: "darkpink",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                        pointHoverRadius: 1,
                    },
                    {
                        label: "DG Total (kW)",
                        data: res.data.map((item) => parseFloat(item.TOT_DG_KW) || 0),
                        borderColor: "black",
                        backgroundColor: gradientFill,
                        tension: 0.3,
                        fill: true,
                        borderWidth: 2,
                        pointRadius: 0.9,
                        pointHoverRadius: 1,
                    },
                ];

                setChartLabels(labels);
                setChartData(datasets);

                // console.log("hourlydara", res)
            } else {
                setLogData([]);
            }
        } catch (err) {
            setError("Failed to fetch data. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const createGradientShade = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, 0, 400);
        gradient.addColorStop(0, palette.primary.main);
        gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
        return gradient;
    };

    useEffect(() => {
        setGradientFill(createGradientShade());
    }, [palette.primary.main]);

    // useEffect(() => {
    //     fetchLogData();
    // }, [startDate, endDate, gradientFill]);

    useEffect(() => {
        fetchLogData();
    }, [gradientFill]);


    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // Define keys to exclude (you can also define keys to include instead)
    const excludeKeys = ["LOC_CODE"]; // Replace "key1", "key2" with actual keys you don't want to export

    // Filter logData
    const filteredLogData = logData.map((item) => {
        const filteredItem = {};
        Object.keys(item).forEach((key) => {
            if (!excludeKeys.includes(key)) {
                filteredItem[key] = item[key]; // Include keys not in excludeKeys
            }
        });
        return filteredItem;
    });

    // Get table headers from filteredLogData
    const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

    // Export to Excel
    const exportToExcel = () => {
        const ws = XLSX.utils.json_to_sheet(filteredLogData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Plant Power Curve");
        XLSX.writeFile(wb, `Plant Power Curve To ${endDate.replace(" ", "T")} Plant Power Curves.xls`);
    };

    // Export to PDF
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Add Logo (x, y, width, height)
        const imgWidth = 30;  // Adjust width
        const imgHeight = 20; // Adjust height
        const xPos = (doc.internal.pageSize.width - imgWidth) / 2;  // Center horizontally
        doc.addImage(logo, 'PNG', xPos, 10, imgWidth, imgHeight);  // Add logo at top

        // Add Title or Text Below the Logo
        const title = `Plant Power Curve To ${endDate.replace(" ", "T")}`;
        doc.setFontSize(12);  // Adjust font size
        doc.text(title, doc.internal.pageSize.width / 2, 35, { align: 'center' });  // Center text below logo

        // Adjust Y position for the table to start below the text
        let startY = 50;  // Push table further down below text

        doc.autoTable({
            head: [tableHeaders],
            body: currentData.map((item) => tableHeaders.map((key) => item[key])),
            startY: startY,  // Start table below the logo and text
            theme: "grid",
        });

        doc.save(`Plant Power Curve To ${endDate.replace(" ", "T")} Plant Power Curves`);
    };


    // Handle the changes when selecting a date
    const handleStartDateChange = (value) => {
        const newDate = new Date(value);
        const formattedDate = formatDateTime(newDate);
        setStartDate(formattedDate); // Update the start date with only hours and minutes
    };

    const handleEndDateChange = (value) => {
        const newDate = new Date(value);
        const formattedDate = formatDateTime(newDate);
        setEndDate(formattedDate); // Update the end date with only hours and minutes
    };

    // Refresh data only when clicking "Show"
function onRefreshData() {
    if (startDate.length !== 0 && endDate.length !== 0) {
        fetchLogData(); // Fetch data only after clicking the button
    } else {
        alert("Please provide valid dates");
    }
}

    return (
        <>
            <Grid ref={chartRef} container  style={{ padding: "0", margin: "0", height: '100vh' }}>


                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ overflow: 'hidden' }}>

                    <Stack rowGap={spacing(0)} sx={{ marginTop: '.4rem', overflow: 'hidden', height: '100%', }}>
                        {/* First Card */}
                        <Stack
                            component={Card}
                            p={spacing(1)}
                            sx={{ height: 'auto', overflow: 'hidden', marginBottom: spacing(2) }}
                        >

                            <div>

                                <div style={{
                                    marginBottom: "5px",
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    gap: "16px",
                                }}>
                                    {/* Left-side title */}
                                    <div style={{ marginLeft: "7px", fontSize: "14px"  }}>
                                        Plant Power Curve
                                    </div>

                                    {/* Right-side date pickers */}
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px"
                                    }}>
                                        
                                        <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                            <span>From:</span>
                                            <input
                                                type="datetime-local"
                                                value={startDate.replace(" ", "T")}
                                                onChange={(e) => handleStartDateChange(e.target.value)}
                                                style={{
                                                    padding: "2px 8px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>
                                        <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                                            <span>To:</span>
                                            <input
                                                type="datetime-local"
                                                value={endDate.replace(" ", "T")}
                                                onChange={(e) => handleEndDateChange(e.target.value)}
                                                style={{
                                                    padding: "2px 8px",
                                                    borderRadius: "14px",
                                                    border: "1px solid #ccc",
                                                }}
                                            />
                                        </label>

                                        <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>

                                        <DownloadJpegButton targetRef={chartRef} fileName={`Plant Power Curve.jpeg`}/>
                                        
                                    </div>
                                </div>
                                 {/* <EnergyChartPower labels={chartLabels} data={chartData} title={``} /> */}
                                 <div ref={chartRef} style={{ width: '100%', height: '400px' }}>
  <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
</div>

                            </div>
                        </Stack>


                    </Stack>


                </Grid>

            </Grid>

        </>
    );
}

//This is dynmically data 

// import React, { useState, useEffect, useContext } from "react";
// import { plantCurveApi } from "../../../../../api/Api";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable";
// import * as XLSX from "xlsx";
// import logo from '../../../../../assets/img/logos/logo 2.png';
// import EnergyChartPower from "../../../../../components/charts/energy_reporting/EnergyChartPower";
// import { Grid, Stack, Button, useTheme, Card } from '@mui/material';
// import { AppThemeContext } from "../../../../../context/AppThemeContext";

// const formatDateTime = (date) => {
//     const pad = (num) => String(num).padStart(2, "0");
//     return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
// };

// export default function PlantCurveData() {
//     const { PrimaryColor } = useContext(AppThemeContext);
//     const { spacing, palette, shape: { borderRadius } } = useTheme();

//     const now = new Date();
//     const initialStartDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 5, 0);
//     const initialEndDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 20, 0);

//     const [startDate, setStartDate] = useState(formatDateTime(initialStartDate));
//     const [endDate, setEndDate] = useState(formatDateTime(initialEndDate));
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [gradientFill, setGradientFill] = useState(null);

//     const [chartLabels, setChartLabels] = useState([]);
//     const [chartData, setChartData] = useState([]);

//     const credentials = {
//         LOGIN_ID: localStorage.getItem("LoginID") || "",
//         PASS_KEY: localStorage.getItem("KEY") || "xyz",
//         LOC_CODE: localStorage.getItem("LCODE") || "",
//         DT1: startDate,
//         DT2: endDate,
//         WEB_KEY: "WEBXYZ321"
//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);
//         try {
//             const res = await plantCurveApi(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);

//                 const labels = res.data.map((item) => item.datet);

//                 const firstItem = res.data[0] || {};

//                 // This code for not includes
//                 const excludedKeys = ["datet", "sn", "loc_code"];

//                 const numericKeys = Object.keys(firstItem).filter(
//                   key =>
//                     !excludedKeys.includes(key.toLowerCase()) &&
//                     !isNaN(parseFloat(firstItem[key]))
//                 );
                
                  

//                 const colors = [
//                     "red", "blue", "green", "orange", "purple", "brown", "pink", "teal", "gray", "gold"
//                 ];

//                 const datasets = numericKeys.map((key, index) => ({
//                     label: key.replace(/_/g, " "),
//                     data: res.data.map(item => parseFloat(item[key]) || 0),
//                     borderColor: colors[index % colors.length],
//                     backgroundColor: gradientFill,
//                     tension: 0.3,
//                     fill: true,
//                     borderWidth: 2,
//                     pointRadius: 0.9,
//                     pointHoverRadius: 1,
//                 }));

//                 setChartLabels(labels);
//                 setChartData(datasets);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             setError("Failed to fetch data. Please try again.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     const createGradientShade = () => {
//         const canvas = document.createElement("canvas");
//         const ctx = canvas.getContext("2d");
//         const gradient = ctx.createLinearGradient(0, 0, 0, 400);
//         gradient.addColorStop(0, palette.primary.main);
//         gradient.addColorStop(1, "rgba(255, 255, 255, 0)");
//         return gradient;
//     };

//     useEffect(() => {
//         setGradientFill(createGradientShade());
//     }, [palette.primary.main]);

//     useEffect(() => {
//         if (gradientFill) {
//             fetchLogData();
//         }
//     }, [gradientFill]);

//     const handleStartDateChange = (value) => {
//         setStartDate(formatDateTime(new Date(value)));
//     };

//     const handleEndDateChange = (value) => {
//         setEndDate(formatDateTime(new Date(value)));
//     };

//     const onRefreshData = () => {
//         if (startDate && endDate) {
//             fetchLogData();
//         } else {
//             alert("Please provide valid dates");
//         }
//     };

//     return (
//         <Grid container style={{ padding: "0", margin: "0", height: '100vh' }}>
//             <Grid item xs={12}>
//                 <Stack spacing={2} sx={{ mt: 1 }}>
//                     <Card sx={{ p: 2 }}>
//                         <div style={{
//                             marginBottom: "5px",
//                             display: "flex",
//                             justifyContent: "space-between",
//                             alignItems: "center",
//                             gap: "16px",
//                         }}>
//                             <div style={{ marginLeft: "7px", fontSize: "10px" }}>
//                                 Plant Power Curve
//                             </div>
//                             <div style={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: "10px"
//                             }}>
//                                 <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                     <span>From:</span>
//                                     <input
//                                         type="datetime-local"
//                                         value={startDate.replace(" ", "T")}
//                                         onChange={(e) => handleStartDateChange(e.target.value)}
//                                         style={{
//                                             padding: "2px 8px",
//                                             borderRadius: "14px",
//                                             border: "1px solid #ccc",
//                                         }}
//                                     />
//                                 </label>
//                                 <label style={{ display: "flex", alignItems: "center", gap: "4px" }}>
//                                     <span>To:</span>
//                                     <input
//                                         type="datetime-local"
//                                         value={endDate.replace(" ", "T")}
//                                         onChange={(e) => handleEndDateChange(e.target.value)}
//                                         style={{
//                                             padding: "2px 8px",
//                                             borderRadius: "14px",
//                                             border: "1px solid #ccc",
//                                         }}
//                                     />
//                                 </label>
//                                 <Button onClick={onRefreshData} variant="contained" sx={{
//                                     color: 'white', p: 0, m: 0, fontSize: '12px',
//                                     backgroundColor: palette.tintBlue,
//                                     borderRadius: borderRadius
//                                 }}>
//                                     Show
//                                 </Button>
//                             </div>
//                         </div>
//                         <EnergyChartPower labels={chartLabels} data={chartData} title={``} />
//                     </Card>
//                 </Stack>
//             </Grid>
//         </Grid>
//     );
// }
